import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PageWidth = "desk" | "narrow" | "platform" | "full";

const widthStyle: Record<PageWidth, string | undefined> = {
  desk: "var(--desk-main-max)",
  narrow: "var(--desk-narrow-max)",
  platform: "32rem",
  full: undefined,
};

/**
 * Shared page rhythm — plan/35.
 * Title → optional context → primary work → secondary panels.
 */
export function PageFrame(props: {
  children: ReactNode;
  /** Content max width. Desk shell already caps; use narrow for forms/settings. */
  width?: PageWidth;
  className?: string;
  /** Skip default vertical padding (rare). */
  flush?: boolean;
}) {
  const width = props.width ?? "desk";
  return (
    <div
      className={cn(
        "w-full animate-[fadeIn_280ms_ease-out]",
        !props.flush && "pb-2",
        props.className,
      )}
      style={
        width === "full"
          ? undefined
          : { maxWidth: widthStyle[width], marginInline: "auto" }
      }
    >
      {props.children}
    </div>
  );
}
